import React, {useState , useEffect,useRef, useDebugValue} from 'react'
// import Dialog from '@mui/material/Dialog';
import Button from '@mui/material/Button';
import { bgColors } from '../utils/bgColor';
import { useSelector } from 'react-redux';
import { useDispatch} from 'react-redux';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import DownloadSharpIcon from '@mui/icons-material/DownloadSharp';
import { Divider, Grid, Typography } from '@mui/material';
import ChevronLeftSharpIcon from '@mui/icons-material/ChevronLeftSharp';
import {RiPlantFill} from 'react-icons/ri'
import {year_season_yield_icon}  from './SampleData/AnalysisWindowConst'
import LandView from './Reports/LandView';
import { fetchrootpath } from '../api_servcies/apirootpath';
import axios from 'axios';
import { mapLocationData,mapSeasonCover,
        storeIndexTsHist,MonthlyMappedIndexNdvi_S2_SAR,
        CropPerfTable, SeasonScoreAggregate,CropPerfMoistureTable,
        sumMoisture,sumPerformance
        } from '../HelperFunctions/AnalysisWindowHelper';
import {Queryparamsindex,index_url} from "../HelperFunctions/SatIndexQueryParam"
import { ScoreConst } from '../ScoreConst/ScoreConst';
import {barChartData,MultibarChart} from '../HelperFunctions/Charts/SeasonPerfBarChart'
import {perfDataDonut,irrigationDataDonut} from "../HelperFunctions/Charts/AnualPerfDonut"
import {BootstrapDialog,BootstrapDialogTitle} from '../FormComopents/Form/CustomDialog'
import {closeAnalysisWindow, openCurrentFolioDialog ,} from '../../redux/actions/controlbuttonaction'
import html2canvas from "html2canvas";
import {Feature_area} from './Container/GeometryFucntions'
import JsPDF from 'jspdf';


// const Transition = React.forwardRef(function Transition(
//   props,ref,
// ) {
//   return <Slide direction="up" ref={ref} {...props}/>;
// });
// const generatePDF = () => {

//   const report = new JsPDF('portrait','pt','a4');
//   report.html(document.querySelector('#report')).then(() => {
//       report.save('report.pdf');
//   });
// }


const AnalaysisWindow=(props) => {

const {analysisWindowOpen} = props
const  selected_geom= useSelector((state) => state.mapreducer.selectedfeature)
const driving_dist = useSelector((state) => state.mapreducer.navroutedata.distance)
// console.log(driving_dist)
const dispatch = useDispatch()
const pdfRef = useRef(null);
const URL_PolyLocation = `${fetchrootpath}/featurelocation`
const URL_PolyCrop = `${fetchrootpath}/featurecrop`
const selected_index_vegetation = 'NDVI_VAL'
const sar_vegetation_index  = 'SAR_VEGETATION_INDEX'
const selected_index_moisture = 'MOISTURE_VAL'
// SAR_NDVI_VAL
const unique_year = Array.from(new Set(year_season_yield_icon.map(({year}) => year)));

const stylemaster = {
  Typography_header:{
    marginLeft:'0rem  ', 
    fontSize: 24, 
    fontFamily:'roboto'
  },

  GridContainerReportTitle: {
    display:'flex',
    direction:'row',
    justifyContent:'flex-start'
  }


}

function annual_perf(year){
  let table_data = []
  let results = year_season_yield_icon.filter(item => {
    return item.year === year;
  });
  for (let i =0; i < 3; i++){
    let _var = {
      season: results[i].season,
      Yieldscore: results[i].yield_score,
      Irrigation: results[i].irrigation
    }
    table_data.push(_var)
  }
  return table_data
}
const[ resultPolyLocation, setResultPolyLocation] = useState({
  loading: false,
  locdata: {},
  })
const[ resultPolyCrop, setResultPolyCrop] = useState({
  loading: false,
  cropdata: [],
  seasonal_crop_cover:[
    {season:'Summer', crop: false},
    {season:'Kharif', crop: false},
    {season:'Rabi', crop: false},
    {season:'Annual', crop: false},
    {season:'Semi_perenial', crop: false},
    {season:'Perennial', crop: false}
  ]
  })

const[ resultVegetationIndex, setResultVegetationIndex] = useState({
  loading: false,
  vegetationIndex: [],
  vegetationHist:[]
  })
const[ sarVegetationIndex, setSarVegetationIndex] = useState({
  loading: false,
  sarvegetationIndex: [],
  sarvegetationHist:[]
  })
const[ resultMoistureIndex, setResultMoistureIndex] = useState({
  loading: false,
  moistureIndex: [],
  moistureHist:[]
  })


let geomstr
let poly_str
if(selected_geom!==undefined && selected_geom.coords.length>0){
  geomstr = selected_geom.coords[0].map(item => `${item[0]} ${item[1]}`).join(',')
  poly_str = `POLYGON((${geomstr}))`
}

useEffect(()=> {
if(selected_geom!==undefined && selected_geom.coords.length>0)
 {const load = async() => {
    const feture_area = Feature_area(selected_geom.coords)
    const feature_distance = (driving_dist/1000).toFixed(2)
    const area_var = {area_acre: Feature_area(selected_geom.coords).toFixed(2)}
    const distanc_var = {driving_distance:feature_distance}

    setResultPolyLocation({...resultPolyLocation, loading:true})
    axios.get(URL_PolyLocation, {
        params: {
          'polystr': poly_str,
            }
      }).then((response)=> {
            // console.log(response.data)
            setResultPolyLocation({...resultPolyLocation,
              loading:false,
              locdata:{...mapLocationData(response.data),...area_var,...distanc_var}      
            })
      })
      .catch(function (error) {
        if (error.response) {
          console.log(error.response)
          // Request made and server responded
          console.log(error.response.data);
          console.log(error.response.status);
          console.log(error.response.headers);
        } else if (error.request) {
          // The request was made but no response was received
          console.log(error.request);
        } else {
          // Something happened in setting up the request that triggered an Error
          console.log('Error', error.message);
        }
      })
    
      // .catch(error => {
      //   setResultPolyLocation({...resultPolyLocation,
      //     loading:false,
      //     locdata: error         
      //   })
      //   // setResult({ errorMessage: error.message })
      //   console.error('There was an error!', error);
      // });
 }
 load()
}
},[poly_str])

// console.log(resultPolyLocation)

useEffect(()=> {
  if(selected_geom!==undefined && selected_geom.coords.length>0){
  const load = async() => {
    
     setResultPolyCrop({...resultPolyCrop, loading:true})
     axios.get(URL_PolyCrop, {
         params: {
           'polystr': poly_str,
             },
        //  headers: {'Access-Control-Allow-Origin' : '*'},
       }).then((response)=> {
         setResultPolyCrop({...resultPolyCrop,
            loading: false,
             cropdata:response.data,
             seasonal_crop_cover: mapSeasonCover(response.data)
         })
      
       })
       .catch(error => {
        setResultPolyCrop({...resultPolyCrop,
          loading:false,
          cropdata:error,
          seasonal_crop_cover: error
        })
         console.error('There was an error!', error);
       });
  }
  load()
}
 },[poly_str])


 useEffect(()=> {
  if(selected_geom!==undefined && selected_geom.coords.length>0){
  const load = async() => {
     setResultVegetationIndex({...resultVegetationIndex, loading:true})
     axios.get(index_url, {
         params: Queryparamsindex(selected_index_vegetation,poly_str)
       }).then((response)=> {
         setResultVegetationIndex({...resultVegetationIndex,
             loading:false,
             vegetationIndex: storeIndexTsHist(response.data.C0).data_ts,
             vegetationHist: storeIndexTsHist(response.data.C0).data_hist              
         })

       })
       .catch(error => {
        
        setResultVegetationIndex({...resultVegetationIndex,
          loading:false,
          vegetationIndex: error,
          vegetationHist: error              
      })

         console.error('There was an error!', error);
       });
  }
  load()
}
 },[poly_str])


 useEffect(()=> {
  if(selected_geom!==undefined && selected_geom.coords.length>0){
  const load = async() => {
    setSarVegetationIndex({...sarVegetationIndex, loading:true})
     axios.get(index_url, {
        params: Queryparamsindex(sar_vegetation_index,poly_str),
        // headers: {'Access-Control-Allow-Origin' : '*'},
       }).then((response)=> {
         setSarVegetationIndex({...sarVegetationIndex,
             loading:false,
             sarvegetationIndex: storeIndexTsHist(response.data.C0).data_ts,
             sarvegetationHist: storeIndexTsHist(response.data.C0).data_hist              
         })
       })
       .catch(error => {
        setSarVegetationIndex({...sarVegetationIndex,
          loading:false,
          sarvegetationIndex: error,
          sarvegetationHist: error              
      })
        console.error('There was an error!', error);
        // alert('There was an error!', error)
       });
  }
  load()
}
 },[poly_str])

 useEffect(()=> {
  if(selected_geom!==undefined && selected_geom.coords.length>0){
  const load = async() => {
     setResultMoistureIndex({...resultMoistureIndex, loading:true})
     axios.get(index_url, {
         
         params: Queryparamsindex(selected_index_moisture,poly_str),
        //  headers: {'Access-Control-Allow-Origin' : *},
       },
       
       
       ).then((response)=> {
        // console.log(response.data)
         setResultMoistureIndex({...resultMoistureIndex,
             loading:false,
             moistureIndex: storeIndexTsHist(response.data.C0).data_ts,
             moistureHist: storeIndexTsHist(response.data.C0).data_hist              
         })
       })
       .catch(error => {
        setResultMoistureIndex({...resultMoistureIndex,
          loading:false,
          moistureIndex: error,
          moistureHist: error              
      })
        //  console.error('There was an error!', error);
       });
  }
  load()
}
 },[poly_str])

function S2_SAR_VEGETATION(){
  let S2SarCommpositVegetation =[]
  let s2index
  let sarIndex
  s2index = resultVegetationIndex.vegetationIndex
  sarIndex = sarVegetationIndex.sarvegetationIndex
  S2SarCommpositVegetation = MonthlyMappedIndexNdvi_S2_SAR(
    s2index, sarIndex
  )
    return S2SarCommpositVegetation
}

const [dataLoader, setDataLoader] = useState({
  polyLoccationLoading:true,
  polyCropLoading:true,
  s2VegetationIndexloading:true,
  sarVegetationindexLoading:true,
  s2MoistureIndexLoading:true,
  scoreLoading: true
  })
const [S2SarCompositVegetation , setS2SarCompositVegetation] = useState([])
const [PerformanceTable, setPerformanceTable] = useState([])
const [moistureScoreTable, setMoistureScoreTable] = useState([])
const [seasonalPerf ,setSeasonalPerf] = useState({
  perfData: [],
  barchartdata: {}
})
const [multiBarDataSet ,setMultibarDataSet] = useState({
  barchartdata: {}
})

  
const [totalPerf ,setTotalPerfScore] = useState({
  perfData: [],
  irigationData:[],
  donutDataPerf: {},
  donutDataMoisture: {}

})
const [yearseasonBardata, setYearseasonBardata] = useState([])


function getPageState(){
  if (resultPolyLocation.loading===true ||
    resultPolyCrop.loading ===true||
    resultVegetationIndex.loading ===true||
    sarVegetationIndex.loading===true||
    resultMoistureIndex.loading===true 
    )
    return true
   else{
    return false
   }

}

function LoadDataState (data){
return data.loading
}
useEffect(()=> {
setDataLoader({
  polyLoccationLoading:LoadDataState(resultPolyLocation),
  polyCropLoading:LoadDataState(resultPolyCrop),
  s2VegetationIndexloading:LoadDataState(resultVegetationIndex),
  sarVegetationIndexloading:LoadDataState(sarVegetationIndex),
  s2MoistureIndexloading:LoadDataState(resultMoistureIndex),
  scoreLoading:getPageState()

})
},[
resultPolyLocation.loading,
resultPolyCrop.loading,
resultVegetationIndex.loading,
sarVegetationIndex.loading,
resultMoistureIndex.loading

])

useEffect(()=> {
  setS2SarCompositVegetation(S2_SAR_VEGETATION())
},[resultVegetationIndex,sarVegetationIndex])

useEffect(()=> {
  let crop_table = resultPolyCrop.cropdata
  let score = ScoreConst
  let vegetaton_index = S2SarCompositVegetation
  let  perftable = CropPerfTable(crop_table,score,vegetaton_index)
  setPerformanceTable(perftable)
},[S2SarCompositVegetation,resultPolyCrop.cropdata])


useEffect(()=> {
  let crop_table = resultPolyCrop.cropdata
  let score = ScoreConst
  let moisture_index = resultMoistureIndex.moistureIndex
  let moisturetable = CropPerfMoistureTable(crop_table,score,moisture_index)
  setMoistureScoreTable(moisturetable)
},[resultMoistureIndex.moistureIndex,resultPolyCrop.cropdata])

useEffect(()=> {
  const data_table = SeasonScoreAggregate(PerformanceTable)
  let barData = barChartData(data_table,'SeasonalPerformance')
  setSeasonalPerf({...seasonalPerf,
    perfData:data_table,
    barchartdata:barData
  })
},[PerformanceTable])

useEffect(()=> {
  let barData = MultibarChart(PerformanceTable)
  setMultibarDataSet({...multiBarDataSet,
    barchartdata:barData
  })
},[PerformanceTable])

useEffect(()=> {
  setTotalPerfScore({...totalPerf, 
    perfData: sumPerformance(PerformanceTable),
    irigationData:sumMoisture(moistureScoreTable),
    donutDataPerf: perfDataDonut(PerformanceTable),
    donutDataMoisture: irrigationDataDonut(moistureScoreTable)
  })
},[moistureScoreTable])


// const file_name = resultPolyLocation.locdata

const file_name =  `${resultPolyLocation.locdata.state}`
                    +"_"
                    +`${resultPolyLocation.locdata.district}`
                    +"_"
                    +`${resultPolyLocation.locdata.sub_district}`
                    +"_"
                    +`${resultPolyLocation.locdata.village}`
                    +"_"
                    +`${resultPolyLocation.locdata.survey_no}`


// const handleDownload = SavePdf(pdfRef.current,file_name)
                    
const handleDownload = () => {
  window.scrollTo(0, 0);
      const divToPrint = pdfRef.current
      html2canvas(divToPrint).then(canvas => {
          const imgData = canvas.toDataURL('image/png');
          const imgWidth = 105;
          const pageHeight = 290;
          const imgHeight = (canvas.height * imgWidth) / canvas.width;
          let heightLeft = imgHeight;
          const doc = new JsPDF('pt', 'mm');
          let position = 0;
          doc.addImage(imgData, 'PNG', 10, 0, imgWidth, imgHeight + 25);
          heightLeft -= pageHeight;
          while (heightLeft >= 0) {
              position = heightLeft - imgHeight;
              doc.addPage();
              doc.addImage(imgData, 'PNG', 10, position, imgWidth, imgHeight + 25);
              heightLeft -= pageHeight;
          }
          doc.save(file_name);
      });
};


  return (
    <BootstrapDialog 
    // ref={pdfRef}
    onClose={() => dispatch(closeAnalysisWindow)}
    aria-labelledby="customized-dialog-title"
    open={analysisWindowOpen}
    scroll="paper"
    sx={{
        "& .MuiDialog-container": {
           alignItems: "flex-start",
           "& .MuiPaper-root": {
                    width: "100%",
                    minHeight:"400px",
                    marginTop:'0.15rem',
                    marginLeft:'0rem'
                },
        },
     }}
    
    PaperProps={{sx: {position:'fixed' , marginLeft:'0.5rem', top:10, left:0} ,style:{borderRadius: 15,
    background:bgColors.default_backgroun_grey
    // background:bgColors.grey_400
    }}}
  >
    <div  ref={pdfRef}>
    
    <BootstrapDialogTitle 
    // ref={pdfRef}
    id="survey_search" onClose={() => dispatch(closeAnalysisWindow)} 
    sx ={{color:bgColors.green_700}}>
      <Grid container spacing={2} style = {stylemaster.GridContainerReportTitle} >
      <Grid item>
      <RiPlantFill/>
      </Grid>
      <Grid item>
      <Typography  style={stylemaster.Typography_header}>
        Field View
     </Typography >
     </Grid>
     </Grid>
    </BootstrapDialogTitle>
    <DialogContent dividers  >
      <LandView 
        location_data={resultPolyLocation.locdata}
        unique_year={unique_year}
        season_crop_cover = {resultPolyCrop.seasonal_crop_cover}
        annual_perf={annual_perf}
        perfDonutData={totalPerf.donutDataPerf}
        irrigationDonutData={totalPerf.donutDataMoisture}
        dataLoader= {dataLoader}
        SeasonalPerfBarData ={seasonalPerf.barchartdata}
        multiBarDataSet={multiBarDataSet.barchartdata}
        />
      
    </DialogContent>
    </div>

    <DialogActions>
    <Grid container sx = {{display:'flex', direction:'column', justifyContent:'flex-end'}}>
    <Button key = {'open_menu_button'} size='small' sx={{marginRight:'0.5rem'}} 
     onClick ={()=> dispatch(openCurrentFolioDialog)}
    >
    <ChevronLeftSharpIcon sx={{ mr: 1}} />
      go back
    </Button>
    <Grid>
    <Divider orientation='vertical' style = {{backgroundColor:bgColors.grey_100}}/>
    </Grid>
    <Button key = {'download-report-button'} 
    onClick={handleDownload}
    // onClick = {SavePdf(pdfRef.current,file_name)}
    
    >
      save
    <DownloadSharpIcon/>
    </Button>
    </Grid>
    </DialogActions>
  </BootstrapDialog>



//     <Dialog 
//       // fullScreen
//       open={analysisWindowOpen}
//       // onClose={() => dispatch(closeAnalysisWindow)}
//       TransitionComponent={Transition}
//       >
//         <LandView 
//         location_data={resultPolyLocation.locdata}
//         unique_year={unique_year}
//         season_crop_cover = {resultPolyCrop.seasonal_crop_cover}
//         annual_perf={annual_perf}
//         perfDonutData={totalPerf.donutDataPerf}
//         irrigationDonutData={totalPerf.donutDataMoisture}
//         dataLoader= {dataLoader}
//         SeasonalPerfBarData ={seasonalPerf.barchartdata}
//         multiBarDataSet={multiBarDataSet.barchartdata}
//         />

// </Dialog>
);
}

export default AnalaysisWindow

